<template>
    <div>
			<div class="ts-flex ts-justify-between">
        <div>
          <a-range-picker
            v-model="dateRange"
            :allowClear="false"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            style="width:200px"
            v-tooltip="$t('stockConfirm.stockInDate')"
            @change="fetchData()"
          />
        </div>
        <div class=" ts-flex ts-space-x-3">
            <!-- <select class="form-control" 
            v-model="status"
            @change="fetchData()"
          >
            <option :value="0">Pendding</option>
            <option :value="1">Confirmed</option>
          </select> -->
          <a-select
            v-model="status"
            mode="multiple"
            @change="fetchData()"
            :maxTagCount="1"
            style="width:200px"
          >
            <a-select-option :value="0">Pendding</a-select-option>
            <a-select-option :value="1">Confirmed</a-select-option>
          </a-select>
          <ts-input
            v-model="search"
            v-tooltip="$t('stockConfirm.search')"
            :placeholder="$t('search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
			</div>
      <div class="overflow-auto ts-mt-3">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.branch.branch_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.stock_in_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.stock_in_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.purchase_order ? record.purchase_order.po_number : null }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_no }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.supplier ? record.supplier.vendor_name : null }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.location.location_name_en }}</td>
            <td class="ts-text-center ts-cursor-pointer"
              v-tooltip="record.remarks"
            >
                <span class="badge badge-default" v-if="record.is_confirm_stock">Confirmed</span>
                <span class="badge badge-info" v-else>Pendding</span>
            </td>
						<td class="ts-text-center">{{ record.confirmed_date }}</td>
						<td class="ts-text-center">{{ record.comfirmed_by ? record.comfirmed_by.name : null }}</td>
						<td class="text-center ts-space-x-3">
							<a href="#" v-tooltip="$t('view')" class="text-primary" @click.prevent="onView(record)">
								<i class="fas fa-eye"></i>
							</a>
							<a href="#" v-tooltip="$t('edit')" 
                class="text-primary" 
                @click.prevent="onEdit(record)"
                v-if="record.is_confirm_stock"
              >
								<i class="fas fa-edit"></i>
							</a>
						</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
	name: 'stockInList',
	data(){
		return{
      loading: false
		}
  },
  created(){
    this.$store.state.stock.stockInConfirm.dateRange = [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')]
    this.fetchData()
  },
  computed: {
    ...mapState('stock/stockInConfirm', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stock.stockInConfirm.search
      },
      set(newValue) {
        this.$store.commit('stock/stockInConfirm/SET_SEARCH', newValue)
        this.$store.commit('stock/stockInConfirm/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get() {
        return this.$store.state.stock.stockInConfirm.is_confirm
      },
      set(newValue) {
        this.$store.commit('stock/stockInConfirm/SET_STATUS', newValue)
      }
    },
    dateRange: {
      get() {
        return this.$store.state.stock.stockInConfirm.dateRange
      },
      set(newValue) {
        this.$store.commit('stock/stockInConfirm/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('stockConfirm.branch') },
        { name: this.$t('stockConfirm.stockInDate') },
        { name: this.$t('stockConfirm.stockInNumber') },
        { name: this.$t('stockConfirm.poNumber') },
        { name: this.$t('stockConfirm.referenceInvoice') },
        { name: this.$t('stockConfirm.supplier/vendor') },
        { name: this.$t('stockConfirm.warehouse') },
        { name: this.$t('stockConfirm.status'),  style: 'text-align:center; width:7%'},
        { name: this.$t('stockConfirm.confirmDate'),  style: 'text-align:center; width:7%'},
        { name: this.$t('stockConfirm.confirmBy'),  style: 'text-align:center; width:7%'},
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    }
  },
	methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/stockInConfirm/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
		onView(record){
			this.$store.commit('stock/stockInConfirm/SET_EDIT_DATA', record)
			this.$router.push({ name: 'stock-confirm-stock-in', params:{ id: record.stock_in_id }})
		},
    branchFilter(value){
      this.$store.commit('stock/stockInConfirm/SET_BRANCH_ID', value)
      this.fetchData()
    },
    onEdit(record){
      this.$router.push({ name: 'stock-confirm-edit-serial', params:{ stockId: record.stock_in_id } })
    }
	},
	watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  }
}
</script>